import React from 'react';
import { Link } from 'react-router-dom';
import { useMappingDrillDown } from '@/context/MappingDrillDownContext';
import { searchContext } from '@/context/Context';
import { getAllColumns } from '../index';

function toPlainText(node: any): string {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(toPlainText).join('');
  if (node?.props?.children != null) return toPlainText(node.props.children);
  return '';
}

function MappingButton({ config, displayValue }: { config: any; displayValue: React.ReactNode }) {
  const { useDrillDown, pushLevel } = useMappingDrillDown();
  const { setMappingContent } = searchContext() ?? {};

  const { name, mappingItems, columVisibilityModelKey, tabSegment, viewSegment = '/summary' } = config;
  const column = getAllColumns().find((c: any) => c.name === name);
  const headerLabel =
    (column?.header as any)?.props?.children ??
    (typeof (column?.header as any) === 'string' ? column?.header : null) ??
    name;
  const headerText = toPlainText(headerLabel).trim();
  const levelLabel = headerText || name;

  const handleClick = () => {
    if (useDrillDown && pushLevel) {
      pushLevel({
        label: levelLabel,
        labelNode: column?.header ?? undefined,
        isBase: false,
        mappingContent: {
          name,
          tabSegment,
          viewSegment,
          mappingItems: mappingItems ?? [],
          columVisibilityModelKey,
        },
      });
    } else if (typeof setMappingContent === 'function') {
      setMappingContent(() => ({
        name,
        isActive: true,
        tabSegment,
        viewSegment,
        mappingItems,
        columVisibilityModelKey,
      }));
    }
  };

  return (
    <button type="button" className="tab-links" onClick={handleClick}>
      {displayValue}{' '}
    </button>
  );
}

export const renderMappingButton = (data: any, config: any) => {
  const { displayValue } = config;
  return <MappingButton config={config} displayValue={displayValue} />;
};

export const renderNavigationLink = (value, url) => {
  return (
    <Link className="tab-links" to={url}>
      {value}{' '}
    </Link>
  );
};
